import React, { Fragment, useState } from "react";
import { PayPalScriptProvider, PayPalButtons } from "@paypal/react-paypal-js";
import { Dialog, Transition } from "@headlessui/react";
import { X } from "lucide-react";
import PayPalCheckout from "./CheckoutForm";
import { useDispatch, useSelector } from "react-redux";
import { selectShowPayPalModal, setMakePersonaliseCourseFree, setPersonalisedSelected, setShowPayPalModal } from "../../redux/addOnSlice";
import { setShowAnimation, setShowCancellationScreen, setShowCartScreen } from "../../redux/otherDetailsSlice";

// Renders errors or successfull transactions on the screen.
function Message({ content }) {
  return <p>{content}</p>;
}

function CheckoutPage({fetchPriceData , score ,personalisedSelected , showAnimation , getOrderStatusFailed ,getOrderStatusSuccess, discountPrice , getSelectedItems ,  utmSource , scholarshipType , originalPrice, getSelectedProducts}) {
  const initialOptions = {
    "client-id": 'Ac2rJO1gLCkcTRyhh0rzpOkHIoc_EYuhU_jlL2mIBXFLH9Vw1BqaV6jhF26ZddxDROhesGuxzc2Zq9iu',
    "enable-funding": "venmo",
    "buyer-country": "US",
    currency: "USD",
    components: "buttons",
  };

  const [message, setMessage] = useState("");
  const showPayPalModal = useSelector(selectShowPayPalModal);
  const dispatch = useDispatch();


  function handleClose () {
        console.log('run');
        dispatch(setShowCancellationScreen(true))
        dispatch(setShowCartScreen(true))
        if(score < 40){
            dispatch(setMakePersonaliseCourseFree(true))
            fetchPriceData(76)
            if(!personalisedSelected){
                dispatch(setPersonalisedSelected())
            }
            dispatch(setShowAnimation(showAnimation + 1))   
        }

        dispatch(setShowPayPalModal(false))
                      }


      
  return (
    <Transition appear show={showPayPalModal} as={Fragment}>
      <Dialog 
        as="div"
        className="relative z-50"
        onClose={() => null}
      >
        {/* Backdrop overlay with fade transition */}
        <Transition.Child
          as={Fragment}
          enter="ease-out duration-300"
          enterFrom="opacity-0"
          enterTo="opacity-100"
          leave="ease-in duration-200"
          leaveFrom="opacity-100"
          leaveTo="opacity-0"
        >
          <div className="fixed inset-0 bg-black/80" aria-hidden="true" />
        </Transition.Child>
        
        {/* Dialog panel with scale and fade transition */}
        <div className="fixed inset-0 flex items-start justify-center overflow-y-auto">
          <Transition.Child
            as={Fragment}
            enter="ease-out duration-300"
            enterFrom="opacity-0 scale-95"
            enterTo="opacity-100 scale-100"
            leave="ease-in duration-200"
            leaveFrom="opacity-100 scale-100"
            leaveTo="opacity-0 scale-95"
          >
            <Dialog.Panel className="mx-auto my-auto max-w-5xl rounded-xl   shadow-xl w-[90%] min-h-auto md:min-h-auto transform transition-all">
            <div className="my-[20px] border-[1px] border-white rounded-xl">
              
              <PayPalCheckout  
                getOrderStatusSuccess={getOrderStatusSuccess} 
                getOrderStatusFailed={getOrderStatusFailed} 
                discountPrice={discountPrice} 
                getSelectedItems={getSelectedItems}
                utmSource={utmSource} 
                scholarshipType={scholarshipType}
                handleClose={handleClose}
                originalPrice={originalPrice}
                getSelectedProducts={getSelectedProducts}
              />
              </div>
            </Dialog.Panel>
          </Transition.Child>
        </div>
      </Dialog>
    </Transition>
  );
}

export default CheckoutPage;